var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { FormProvider, useFieldArray, useForm, useWatch, } from "react-hook-form";
import { FormRow } from "@gravity-ui/components";
import { Button, Checkbox, Flex, Select } from "@gravity-ui/uikit";
// import { CoverUpload } from '@/components/CoverUpload';
import { FileUpload } from "@/components/FileUpload";
import { FormRadioButton, FormSelect, FormTextArea, FormTextInput, } from "@/components/formUi";
import { EditMap } from "@/components/ui/Map";
var COVER_WIDTH = 1200;
var COVER_HEIGHT = 400;
export var PlaceEditForm = function (props) {
    var _a;
    var formMethods = useForm({
        defaultValues: props.data,
    });
    var handleSubmit = formMethods.handleSubmit, formState = formMethods.formState, reset = formMethods.reset, control = formMethods.control;
    var _b = useState(0), rndKey = _b[0], setRndKey = _b[1];
    var _c = useFieldArray({ control: control, name: "sports", keyName: "_itemId" }), placeSports = _c.fields, appendPlaceSport = _c.append, removePlaceSport = _c.remove;
    var _d = useFieldArray({
        control: control,
        name: "coverFiles",
        keyName: "_itemId",
    }), placeCovers = _d.fields, replaceCovers = _d.replace;
    var submitHandler = function (event) {
        handleSubmit(props.onSave)(event);
    };
    var resetFormHandler = function () {
        reset();
        // из-за чекбоксов с видами спорта и точки на карте
        setRndKey(Date.now());
    };
    var sportChangeHandler = function (checked, sport) {
        if (checked) {
            appendPlaceSport(sport);
        }
        else {
            var removeIdx = placeSports.findIndex(function (item) { return item.id === sport.id; });
            removePlaceSport(removeIdx);
        }
    };
    var geoChangeHandler = function (point) {
        formMethods.setValue("latitude", point.latitude, { shouldDirty: true });
        formMethods.setValue("longitude", point.longitude, { shouldDirty: true });
    };
    var coversChangeHandler = function (files) {
        replaceCovers(files);
    };
    var updateCityHandler = function (value) {
        var cityId = value[0];
        var cityName = cityId
            ? props.citiesDict.find(function (el) { return el.id === cityId; }).name
            : "";
        formMethods.setValue("cityName", cityName);
    };
    var cityName = useWatch({ name: "cityName", control: control });
    return (_jsx(FormProvider, __assign({}, formMethods, { children: _jsxs(Flex, { direction: "column", gap: 4, children: [_jsxs(Flex, { direction: "column", children: [_jsx(FormRow, { direction: "row", fieldId: "name", label: "\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", className: "mod", children: _jsx(FormTextInput, { control: control, name: "name", placeholder: "\u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435", autoComplete: "off" }) }), _jsx(FormRow, { direction: "row", fieldId: "description", label: "\u041E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", children: _jsx(FormTextArea, { control: control, name: "description", placeholder: "\u0432\u0432\u0435\u0434\u0438\u0442\u0435 \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435", autoComplete: "off" }) }), _jsx(FormRow, { direction: "row", label: "\u0422\u0438\u043F", children: _jsx(FormRadioButton, { control: control, name: "isIndoor", options: [
                                    { value: "true", content: "Крытая" },
                                    { value: "false", content: "Открытая" },
                                ] }) }), _jsx(FormRow, { direction: "row", label: "\u0411\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u0430\u044F", children: _jsx(FormRadioButton, { control: control, name: "isFree", options: [
                                    { value: "true", content: "Да" },
                                    { value: "false", content: "Нет" },
                                ] }) }), _jsx(FormRow, { direction: "row", label: "\u0412\u0438\u0434\u044B \u0441\u043F\u043E\u0440\u0442\u0430", children: props.sportsDict.map(function (sport) { return (_jsx(Checkbox, { defaultChecked: placeSports.some(function (el) { return el.id === sport.id; }), style: { marginRight: 8 }, onUpdate: function (checked) { return sportChangeHandler(checked, sport); }, size: "xl", children: sport.name }, sport.id)); }) }, rndKey), _jsx(FormRow, { direction: "row", fieldId: "cityId", label: "\u0413\u043E\u0440\u043E\u0434", children: _jsx(FormSelect, { name: "cityId", placeholder: "\u0413\u043E\u0440\u043E\u0434", control: control, onUpdate: updateCityHandler, children: (_a = props.citiesDict) === null || _a === void 0 ? void 0 : _a.map(function (el) { return (_jsx(Select.Option, { value: el.id, children: el.name }, el.id)); }) }) })] }), cityName ? (_jsx(EditMap, { onChange: geoChangeHandler, point: props.mode === "update"
                        ? {
                            latitude: formMethods.getValues("latitude"),
                            longitude: formMethods.getValues("longitude"),
                        }
                        : undefined, city: cityName }, rndKey)) : null, _jsx(FileUpload, { imageHeight: COVER_HEIGHT, imageWidth: COVER_WIDTH, multiple: true, initialFiles: placeCovers.map(function (f) { return ({
                        id: f.id,
                        status: "uploaded",
                        url: f.url,
                        type: "image",
                    }); }), onChange: coversChangeHandler, maxFiles: 10 }), _jsxs(Flex, { gap: 4, children: [_jsx("form", { onSubmit: submitHandler, children: _jsx(Button, { view: "action", type: "submit", disabled: !formState.isDirty, children: "\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C" }) }), _jsx(Button, { view: "normal", disabled: !formState.isDirty, onClick: resetFormHandler, children: "\u0421\u0431\u0440\u043E\u0441\u0438\u0442\u044C" })] })] }) })));
};
